'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { useState, useEffect, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import useEmblaCarousel from 'embla-carousel-react';
import HomeProductListing from './HomeProductListing';
const HomeFeaturedProducts = t0 => {
  const $ = _c(44);
  const {
    products,
    heading,
    url
  } = t0;
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      loop: false,
      align: "start",
      slidesToScroll: 2,
      containScroll: "trimSnaps"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t1);
  let t2;
  if ($[1] !== emblaApi) {
    t2 = () => {
      if (!emblaApi) {
        return;
      }
      setCanScrollPrev(emblaApi.canScrollPrev());
      setCanScrollNext(emblaApi.canScrollNext());
    };
    $[1] = emblaApi;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const updateScrollButtons = t2;
  let t3;
  let t4;
  if ($[3] !== emblaApi || $[4] !== updateScrollButtons) {
    t3 = () => {
      if (!emblaApi) {
        return;
      }
      updateScrollButtons();
      emblaApi.on("select", updateScrollButtons);
      emblaApi.on("reInit", updateScrollButtons);
      return () => {
        emblaApi.off("select", updateScrollButtons);
        emblaApi.off("reInit", updateScrollButtons);
      };
    };
    t4 = [emblaApi, updateScrollButtons];
    $[3] = emblaApi;
    $[4] = updateScrollButtons;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== emblaApi) {
    t5 = () => {
      if (emblaApi) {
        emblaApi.scrollPrev();
      }
    };
    $[7] = emblaApi;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const scrollPrev = t5;
  let t6;
  if ($[9] !== emblaApi) {
    t6 = () => {
      if (emblaApi) {
        emblaApi.scrollNext();
      }
    };
    $[9] = emblaApi;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const scrollNext = t6;
  if (!products || products.length === 0) {
    return null;
  }
  let t7;
  if ($[11] !== heading) {
    t7 = <h2 className="text-2xl font-extralight me-3 leading-[1] hover:text-primary transition-colors">{heading}</h2>;
    $[11] = heading;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7 || $[14] !== url) {
    t8 = <Link href={url}>{t7}</Link>;
    $[13] = t7;
    $[14] = url;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = `View ${heading} collection`;
  let t10;
  if ($[16] !== t9 || $[17] !== url) {
    t10 = <Link href={url} className="text-3xs text-light underline transition-colors hover:text-primary" aria-label={t9}>View Collection</Link>;
    $[16] = t9;
    $[17] = url;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t8) {
    t11 = <div className="flex items-end mb-8">{t8}{t10}</div>;
    $[19] = t10;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== canScrollNext || $[23] !== canScrollPrev || $[24] !== scrollPrev) {
    t12 = (canScrollPrev || canScrollNext) && <button onClick={scrollPrev} disabled={!canScrollPrev} aria-label="Previous products" className={`absolute left-[0.625rem] top-1/2 -translate-y-1/2 z-40 shrink-0 ${canScrollPrev ? "cursor-pointer" : "cursor-default opacity-30"}`}><div className="w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center hover:shadow-lg transition-shadow"><FontAwesomeIcon icon={faChevronLeft} className="text-dark text-sm" /></div></button>;
    $[22] = canScrollNext;
    $[23] = canScrollPrev;
    $[24] = scrollPrev;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== products) {
    t13 = products.map(_temp);
    $[26] = products;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13) {
    t14 = <div className="flex">{t13}</div>;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== emblaRef || $[31] !== t14) {
    t15 = <div className="flex-1 min-w-0"><div ref={emblaRef} className="overflow-hidden">{t14}</div></div>;
    $[30] = emblaRef;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== canScrollNext || $[34] !== canScrollPrev || $[35] !== scrollNext) {
    t16 = (canScrollPrev || canScrollNext) && <button onClick={scrollNext} disabled={!canScrollNext} aria-label="Next products" className={`absolute right-[1.5rem] top-1/2 -translate-y-1/2 z-40 shrink-0 ${canScrollNext ? "cursor-pointer" : "cursor-default opacity-30"}`}><div className="w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center hover:shadow-lg transition-shadow"><FontAwesomeIcon icon={faChevronRight} className="text-dark text-sm" /></div></button>;
    $[33] = canScrollNext;
    $[34] = canScrollPrev;
    $[35] = scrollNext;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t12 || $[38] !== t15 || $[39] !== t16) {
    t17 = <div className="relative flex items-center -mr-3">{t12}{t15}{t16}</div>;
    $[37] = t12;
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t11 || $[42] !== t17) {
    t18 = <div className="site-padding mb-16 w-full">{t11}{t17}</div>;
    $[41] = t11;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
};
export default HomeFeaturedProducts;
function _temp(product, index) {
  return <div key={`${product.sub_product_id}-${index}`} className="flex-none w-1/2 sm:w-1/3 md:w-1/4 xl:w-1/5 2xl:w-[16.666%] pr-3"><HomeProductListing product={product} /></div>;
}